import { authApi } from './auth';
import { mainServiceURL } from './defines';

export const subscriptionsApi = authApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchCurrentUserSubscriptions: builder.query({
      query: (params: { itemID?: string }) => ({
        url: mainServiceURL + `/subscriptions/current`,
        method: 'GET',
        params,
      }),
      providesTags: ['Subscriptions'],
    }),
    initSubscription: builder.mutation({
      query: (values) => ({
        url: mainServiceURL + `/subscriptions/init-subscription`,
        method: 'POST',
        body: values,
      }),
      invalidatesTags: ['Subscriptions', 'NewsAgent'],
    }),
    downgradeSubscription: builder.mutation({
      query: (values) => ({
        url: mainServiceURL + `/subscriptions/downgrade`,
        method: 'POST',
        body: values,
      }),
      invalidatesTags: ['Subscriptions', 'NewsAgent'],
    }),
    createTrial: builder.mutation({
      query: (values) => ({
        url: mainServiceURL + `/subscriptions/create-trial`,
        method: 'POST',
        body: values,
      }),
      invalidatesTags: ['Subscriptions', 'NewsAgent'],
    }),
    subscribe: builder.mutation({
      query: (values) => ({
        url: mainServiceURL + `/subscriptions/subscribe`,
        method: 'POST',
        body: values,
      }),
      invalidatesTags: ['Subscriptions', 'NewsAgent'],
    }),
    createBillingPortalSession: builder.mutation({
      query: (values) => ({
        url: mainServiceURL + `/subscriptions/update-billing`,
        method: 'POST',
        body: { customerId: values.customerId },
      }),
      invalidatesTags: ['Subscriptions', 'NewsAgent'],
    }),
    createPurchaseSession: builder.mutation({
      query: (values: {
        customerId: string;
        priceId: string;
        quantity: number;
        transactionId?: string;
        subscriptionID?: string;
        returnUrl: string;
      }) => ({
        url: mainServiceURL + `/subscriptions/purchase-session`,
        method: 'POST',
        body: {
          customerId: values.customerId,
          priceId: values.priceId,
          quantity: values.quantity,
          transactionId: values.transactionId,
          subscriptionID: values.subscriptionID,
          returnUrl: values.returnUrl,
        },
      }),
      invalidatesTags: ['Subscriptions', 'NewsAgent'],
    }),
    unsubscribe: builder.mutation({
      query: (id: string) => ({
        url: mainServiceURL + `/subscriptions/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Subscriptions', 'NewsAgent'],
    }),
    buyTokens: builder.mutation({
      query: (values) => ({
        url: mainServiceURL + `/subscriptions/buy-tokens`,
        method: 'POST',
        body: values,
      }),
      invalidatesTags: ['Subscriptions', 'NewsAgent'],
    }),
    retryPayment: builder.mutation({
      query: (id: string) => ({
        url: mainServiceURL + `/subscriptions/retry-payment/${id}`,
        method: 'POST',
      }),
      invalidatesTags: ['Subscriptions'],
    }),
    reactivateSubscription: builder.mutation({
      query: (id: string) => ({
        url: mainServiceURL + `/subscriptions/reactivate/${id}`,
        method: 'POST',
      }),
      invalidatesTags: ['Subscriptions', 'NewsAgent'],
    }),
    updateSubscription: builder.mutation({
      query: (values: {
        id: string;
        autoTopUp: boolean;
        autoTopUpValue: number;
      }) => {
        const { id, ...body } = values;
        return {
          url: mainServiceURL + `/subscriptions/${id}`,
          method: 'PUT',
          body,
        };
      },
      invalidatesTags: ['Subscriptions', 'NewsAgent'],
    }),
  }),
});

export const {
  useFetchCurrentUserSubscriptionsQuery,
  useDowngradeSubscriptionMutation,
  useInitSubscriptionMutation,
  useSubscribeMutation,
  useCreateTrialMutation,
  useCreateBillingPortalSessionMutation,
  useCreatePurchaseSessionMutation,
  useBuyTokensMutation,
  useUnsubscribeMutation,
  useRetryPaymentMutation,
  useReactivateSubscriptionMutation,
  useUpdateSubscriptionMutation,
} = subscriptionsApi;
